/**
 * Simula fila de jobs da Ata Inteligente: pending → success (App faz poll a cada 2s).
 * No success devolve response com transcript/ações (pipeline mock Alice).
 */

import { registerDemoJob } from "./demoJobHistory";
import { buildMockProcessResponse } from "../views/SmartMinutes/fixtures/mockProcessResult";

let phase = "idle";
let lastJob = null;
let lastBody = null;

export function notifyDemoSmartMinutesJobPosted(body) {
  if (!body) {
    return;
  }
  const classId = body.classId || null;
  const title = body.title || body.audioFileName || "Ata Inteligente";
  phase = "pending";
  lastBody = body;
  lastJob = {
    id: `demo-smart-minutes-job-${Date.now()}`,
    status: "pending",
    name: "process_smart_minutes",
    title: classId ? `Turma ${classId} | ${title}` : title,
    ataTitle: title,
    classId,
    draftId: body.draftId || null,
    meetingAt: body.meetingAt || null,
    createdAt: new Date().toISOString(),
    audioFileName: body.audioFileName || null
  };
  registerDemoJob(lastJob);
}

export function takeDemoSmartMinutesJobsResponse() {
  if (phase === "idle" || !lastJob) {
    return [];
  }
  if (phase === "pending") {
    phase = "await_success";
    registerDemoJob({ ...lastJob, status: "pending" });
    return [{ ...lastJob, status: "pending" }];
  }
  if (phase === "await_success") {
    const response = buildMockProcessResponse(lastBody || {});
    const done = {
      ...lastJob,
      status: "success",
      response
    };
    registerDemoJob(done);
    phase = "idle";
    lastJob = null;
    lastBody = null;
    return [done];
  }
  return [];
}
